import '../App.css'
import Cities from './filters/Cities';
import Departments from './filters/Departments';
import PointRange from './filters/PointRange';
import RankRange from './filters/RankRange';
import PointTypes from "./filters/PointTypes";
function Filters({ filters, setFilters }) {
  return (
    <div>
      <PointTypes filters={filters} setFilters={setFilters} />

      <RankRange filters={filters} setFilters={setFilters} />

      <PointRange filters={filters} setFilters={setFilters} />

      <Cities filters={filters} setFilters={setFilters} />

      <Departments filters={filters} setFilters={setFilters} />
    </div>
  );
}

export default Filters;
